import {
  ClientOrder,
  ClientOrderAddress,
  ClientOrderOptions,
  ClientCreateOrder,
} from "../types/order";
import {
  ApiCreateOrder,
  ApiOrderAddress,
  ApiOrderOptions,
  ApiOrder,
} from "../types/order/api-types";

export const OrderAdapter = {
  // getOptions
  toClientOptions(apiOrder: ApiOrderOptions): ClientOrderOptions {
    const convertAddressToClient = (
      apiAddress: ApiOrderAddress,
    ): ClientOrderAddress => ({
      ...apiAddress,
      isPrivateHouse: apiAddress.is_private_house,
    });

    return {
      deliveryTypes: apiOrder.delivery_type,
      deliveryGrouping: apiOrder.delivery_grouping,
      zones: apiOrder.zones.map((zone) => ({
        ...zone,
        deliveryPrice: zone.delivery_price,
        minOrder: zone.min_order,
        freeDelivery: zone.free_delivery,
        availableTime: zone.available_time,
        areas: zone.areas,
      })),
      addresses: apiOrder.addresses
        ? apiOrder.addresses.map(convertAddressToClient)
        : null,
    };
  },

  // postOrder
  toApiPostOrder(order: ClientCreateOrder): ApiCreateOrder {
    if (order.deliveryType === "delivery") {
      return {
        delivery_type: order.deliveryType,
        delivery_grouping: order.deliveryGrouping,
        delivery_price: order.deliveryPrice,
        courier_comment: order.courierComment,
        delivery_time: order.deliveryTime,
        save_address: order.saveAddress,
        address: order.address && {
          ...order.address,
          is_private_house: order.address.isPrivateHouse,
        },
        items: order.items.map((clientItem) => ({
          ...clientItem,
          extra: clientItem.extra,
        })),
      };
    }
    return {
      delivery_type: order.deliveryType,
      delivery_grouping: order.deliveryGrouping,
      delivery_price: order.deliveryPrice,
      courier_comment: order.courierComment,
      delivery_time: order.deliveryTime,
      save_address: order.saveAddress,
      items: order.items.map((clientItem) => ({
        ...clientItem,
        extra: clientItem.extra,
      })),
    };
  },

  toClientOrder(order: ApiOrder): ClientOrder {
    if (order.delivery_type === "delivery") {
      return {
        id: order.id,
        deliveryType: order.delivery_type,
        deliveryGrouping: order.delivery_grouping,
        courierComment: order.courier_comment,
        deliveryTime: order.delivery_time,
        address: order.address && {
          ...order.address,
          isPrivateHouse: order.address.is_private_house,
        },
        items: order.items.map((orderItem) => ({
          ...orderItem,
          imageUrl: orderItem.image_url,
        })),
      };
    }
    return {
      id: order.id,
      deliveryType: order.delivery_type,
      deliveryGrouping: order.delivery_grouping,
      courierComment: order.courier_comment,
      deliveryTime: order.delivery_time,
      items: order.items.map((orderItem) => ({
        ...orderItem,
        imageUrl: orderItem.image_url,
      })),
    };
  },
};
